module.exports = {
  title: 'Dynamic FlatList with React Native Reanimated 👇',
  author: 'Enzo Manuel Mangano',
  date: '2024-02-07',
  slug: 'email-demo',
  tags: ['reanimated', 'gesture-handler'],
};
